<template>
  <div>
    <div class="banner">
      <slide :slidePics="recommend.swipper"></slide>
      <div class="login-position-outerbox">
        <div class="login-box" v-show="!isLogin">
          <div class="login-top-login">
            <div class="login-title">
              <span>账号登录</span>
            </div>
            <div class="login-input-box">
              <!-- <div class="icon-box my_text_center">
                <img src="../assets/imgs/register-phone-icon.png" alt="">
              </div> -->
              <input v-model.lazy="form.mobile" class="login-input-input" type="text" style="width:100%;" placeholder="请输入你的手机号/用户名">
            </div>
            <span v-show="phoneErrWarn" class="warning-text">电话号码或用户名格式错误，请重新输入</span>
            <div class="login-input-box">
              <!-- <div class="icon-box my_text_center">
                <img src="../assets/imgs/register-pwd-icon.png" alt="">
              </div> -->
              <input class="login-input-input" type="password" placeholder="请输入你的密码" v-model.lazy="form.password">
            </div>
            <span v-show="pwdErrWarn" class="warning-text">密码错误，请重新输入</span>
            <div class="login-input-box">
              <!-- <div class="icon-box my_text_center">
                <img src="../assets/imgs/register-pwd-icon.png" alt="">
              </div> -->
              <input class="login-input-input" type="text" placeholder="请输入下方验证码" v-model.lazy="form.smscode">
            </div>
            <div style="width:100%;margin-top:20px;">
                <Verify ref="checkcode" @success="alert('success')" @error="alert('error')" :type="1" :code="form.smscode"></Verify>
              </div>
            <div class="login-btn my_text_center" style="margin-top:12px;margin-bottom:12px;">
              <span style="display:block;" @click="loginHandler">登录</span>
            </div>
            <span v-show="pwdPhoneErrWarn" class="warning-text">账号或密码错误</span>
          </div>
          <div class="login-bottom-register">
            <router-link to="/register" class="special-color">免费注册</router-link>
            <router-link to="/ufindpassword">忘记密码</router-link>
          </div>
        </div>
        <div class="haslogin " v-show="isLogin">
          <div class="welcome-text">
            <p>昵称：{{profile.nickname}}</p>
            <p>豆豆：{{profile.doudou.toLocaleString()}}</p>
            <p>存款：{{profile.deposit.toLocaleString()}}</p>
            <p>经验：{{profile.experience}}</p>
            <p>成长值：{{profile.growth}}</p>
          </div>
          <div style="text-align: center">
            <el-button type="text" @click="jumpTo">使用道具</el-button>
            |
            <el-button type="text" @click="logoutHandler">退出</el-button>
            <!--<span>退出</span>-->
          </div>
          <div style="text-align: center">
            <el-button style="width: 80%;color: #FFF;background-color: #1b9af7;border-color: #1b9af7;">
              <router-link :to="{ name: 'news', params: {userId: userName}}" class="font-color">个人主页</router-link>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="w1200">
      <ul class="one_ul">
        <li class="li01" @click="gotoUrl('g1')">
          <a href="#">
            <i class="ico1"></i>
            <h3>急速系列</h3>
          </a>
        </li>
        <li class="li02" @click="gotoUrl('b1')">
          <a href="#">
            <i class="ico1"></i>
            <h3>比特币系列</h3>
          </a>
        </li>
        <li class="li03" @click="gotoUrl('k1')">
          <a href="#">
            <i class="ico1"></i>
            <h3>宾果系列</h3>
          </a>
        </li>
        <li class="li04" @click="gotoUrl('c1')">
          <a href="#">
            <i class="ico1"></i>
            <h3>加拿大系列</h3>
          </a>
        </li>
      </ul>
    </div>


    <div class="ind_four">
      <div class="w1200">
        <h2 class="comm_h2">关于我们</h2>
        <ul class="four_ul">
          <li>
            <a href="#" class="cl_white">
              <img src="/static/imgs/bjbdn.png" width="260" height="120">
              <h3 class="f18px bold">高额赔率，实力雄厚。</h3>
              <p class="f12px" style="width: 85%;margin: 0 auto;">我们拥有行业内经验丰富的服务团队、市场营销专家。以24小时服务会员不打烊的精神，随时解决会员咨询的问题，让每位会员有宾至如归的感觉。</p>
            </a>
          </li>
          <li>
            <a href="#" class="cl_white">
              <img src="/static/imgs/applex.png" width="260" height="120">
              <h3 class="f18px bold">系统稳定，安全可靠。</h3>
              <p class="f12px" style="width: 85%;margin: 0 auto;">我们凭藉集合资讯专家、先进的软硬件开发人员自主研发，为每一位会员提供最新、最安全的游戏平台、快速稳定的体验效果，开启您精彩刺激的娱乐之旅。</p>
            </a>
          </li>
          <li>
            <a href="#" class="cl_white">
              <img src="/static/imgs/iphone7p.png" width="260" height="120">
              <h3 class="f18px bold">奖励丰富，游戏精彩。</h3>
              <p class="f12px" style="width: 85%;margin: 0 auto;">我们拥有数十种游戏及简单便捷的投注界面。我们将投入大量的人力及资源，策划并研发盛大活动，不断呈现出新的优惠，让您感受到我们的用心。</p>
            </a>
          </li>
          <li>
            <a href="#" class="cl_white">
              <img src="/static/imgs/znsh.png" width="260" height="120">
              <h3 class="f18px bold">老牌代理，信誉至上。</h3>
              <p class="f12px" style="width: 85%;margin: 0 auto;">我们重金聘请数十名行业内最有影响力的老牌代理，24小时在线、担保交易、让您的资金得到保障。我们将让每一个会员得到优质的服务并保证资金安全。</p>
            </a>
          </li>

        </ul>
      </div>
    </div>

    <div class="contact_box" style="margin-top: -107.5px;display:none">
      <a href="javascript:;" class="close"></a>
      <div class="QQ_head">
        <span></span>
        <img src="/static/imgs/QQ.png" style="display: inline-block; width: 59px; height: 68px;">
      </div>
      <div class="cont_zx">
        <h5><em>QQ在线咨询</em><span class="line"></span></h5>
        <ul class="zx_ul">

          <li><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=784851375&amp;site=qq&amp;menu=yes"
                 style="color: #666;"><img border="0" src="/static/imgs/QQ.png"
                                           style="height:18px;width:18px;margin-top:-6px;margin-right:4px;"
                                           alt="感谢您访问数字28！" title="感谢您访问数字28网！">784851375</a></li>

        </ul>
      </div>
      <div class="cont_zx">
        <h5><em>官方交流群</em><span class="line"></span></h5>
        <ul class="zx_ul">

          <li>QQ群7883898</li>

        </ul>
      </div>

    </div>

  </div>
</template>

<script>
  import Slide from "../components/Slide";
  import {mapState, mapGetters, mapActions} from 'vuex';
  import Verify from '@/components/Verify';

  export default {
    computed: {
      ...mapState('home', ['recommend', 'section']),
      ...mapGetters('home', ['navList']),
      ...mapState('user', ['isLogin', 'profile'])
    },
    components: {
      Slide,
      Verify
    },
    data() {
      return {
        parentSlidePics: [],
        isPass:false,
        form: {
          mobile: '',
          password: '',
          smscode: '',
          self: this
        },
        phoneErrWarn:'',
        pwdPhoneErrWarn:'',
        pwdErrWarn:'',
        userName:'',

      };
    },
    created() {
      this.getUserInfo();
      this.getHomeInfo();
      this.open()
    },
    methods: {
      ...mapActions('home', ['getHomeInfo']),
      ...mapActions('user', ['login', 'logout','getUserInfo']),
      logoutHandler() {
        this.logout({self: this}).then(res => {
        })
      },
      loginHandler() {
        let msg = "";
        let getPhone = (/^1[3456789]\d{9}$/).test(this.form.mobile)
        if(this.form.mobile == ''){
            msg = '手机号码必填';
            this.$message.warning(msg);
            return
        }
        if(this.form.password == ''){
            msg = '密码必填';
            this.$message.warning(msg);
            return
        }
        if(this.form.smscode == ''){
            msg = '验证码必填';
            this.$message.warning(msg);
            return
        }
        this.$refs.checkcode.checkCode();
        var self = this
        if(this.isPass){
          this.login(this.form).then(res => {
            if(res.errno == 1){
              sessionStorage.setItem("mobile", this.form.mobile);
              self.form.mobile = ''
              self.form.password = ''
              self.form.smscode = ''
              this.$router.push('/smsVerify');
            }
          })
        }else{
           this.$message.warning('验证码输入错误');
        }
      },
      jumpTo(){
        this.$router.push({path:"/useprops"});
      },
      alert(text) {
        if (text == "success") {
          this.isPass = true;
        } else {
          this.isPass = false;
        }
      },
      gotoUrl(type) {
        if(type == 'g1'){
          sessionStorage.setItem("param", "g")
        }else if(type == 'b1'){
          sessionStorage.setItem("param", "b")
        }else if(type == 'k1'){
          sessionStorage.setItem("param", "k")
        }else if(type == 'c1'){
          sessionStorage.setItem("param", "c")
        }
        sessionStorage.setItem("gtype", type)
        this.$eventBus.$emit('gotoUrl')
        this.$go('/forecastrecommend/1')
      },
      open() {
        this.$alert('<div class="welcome"><p><strong>加拿大牛牛新玩法，百人同桌一把赢爆。</strong></p>'+
                    '<p><strong>简洁界面，玩法简单，万人在线，抢庄玩法！</strong></p>'+
                    '<p><strong>牛气冲天，天降财神，全民参与，真人匹配！</strong></p>'+
                    '<p><strong></strong></p>'+
                    '<p><strong>虚拟体验游戏网站正式上线</strong></p>'+
                    '<p><strong>虚拟网站，同步游戏，免费体验，赢取金币！</strong></p>'+
                    '<p><strong>全民参与，排行奖励，你来投注，我来买单！</strong></p></div>', '', {
          dangerouslyUseHTMLString: true
        });
      }      
    },
  };
</script>

<style lang="less" scoped>
  @import url(../assets/css/index.less);

  .baoti {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
  }

  .haslogin {
    background-color: #fceaf1;
    width: 330px;
    padding: 30px 10px 30px 10px;
    letter-spacing: 2px;
    font-size: 16px;
  }

  .welcome-text {
    text-align: left;
  }

  .welcome-text > p {
    padding-left: 30px;
    padding-top: 15px;
  }
</style>
<style>
.welcome{
  background-image: url("/static/imgs/welcome/welcome.png");
  background-size: 400px 600px;
  background-repeat:no-repeat;
  padding-top: 190px;
  padding-left: 70px;
}
</style>




// WEBPACK FOOTER //
// src/pages/index.vue